export default {
  'expandButton.popupText': {
    id: 'trendTimeline.expandButton.popupText',
    defaultMessage: 'Expand Trends'
  },
  'collapseButton.popupText': {
    id: 'trendTimeline.collapseButton.popupText',
    defaultMessage: 'Collapse Trends'
  }
};